import React, { useState } from "react";
import { Copy, Send, DollarSign, Users, Gift } from "lucide-react";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Card, CardContent } from "../components/ui/card";
import { toast } from "sonner";
import { Link } from "react-router-dom";
import { useContext } from "react";
import GlobalContext from "../context/GlobalContext";
import Navbar from "../components/shared/Navbar";

const ReferralPage = () => {
  const [email, setEmail] = useState("");
  const [referralLink] = useState("examplesite.com/ref=271648");
  const { userInfo } = useContext(GlobalContext);

  //   const handleSendInvite = () => {
  //     if (!email) {
  //       toast({
  //         title: "Email Required",
  //         description: "Please enter an email address to send an invitation.",
  //         variant: "destructive",
  //       });
  //       return;
  //     }

  //     toast({
  //       title: "Invitation Sent!",
  //       description: `Invitation sent to ${email}`,
  //     });
  //     setEmail("");
  //   };

  //   const handleCopyLink = () => {
  //     navigator.clipboard.writeText(referralLink);
  //     toast({
  //       title: "Link Copied!",
  //       description: "Referral link copied to clipboard",
  //     });
  //   };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50 ">
      <Navbar />
      <div className="max-w-6xl mx-auto">
        {/* Main Content */}
        <div className="max-w-2xl mx-auto">
          {/* Title */}
          <div className="text-center mb-12">
            <h1 className="text-4xl font-bold text-emerald-600 mb-2 mt-3">
              Referral
            </h1>
            <div className="w-16 h-1 bg-emerald-500 mx-auto rounded-full"></div>
          </div>

          {/* Invite Friends Section */}
          <Card className="mb-8 shadow-lg border-0 bg-white/80 backdrop-blur-sm">
            <CardContent className="p-8">
              <div className="flex items-center gap-3 mb-4">
                <Users className="w-6 h-6 text-emerald-600" />

                <h2 className="text-2xl font-semibold text-slate-800">
                  Invite Your Friends
                </h2>
              </div>
              <p className="text-slate-600 mb-6 leading-relaxed">
                Add your friends email address and send them invitations to
                join!
              </p>

              <div className="flex flex-col sm:flex-row gap-3">
                <Input
                  type="email"
                  placeholder="Enter email address"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="flex-1 h-12 border-slate-200 focus:border-blue-400 focus:ring-blue-400"
                />
                <Button
                  // onClick={handleSendInvite}
                  className="bg-emerald-600 hover:bg-emerald-700 h-12 px-8 gap-2 whitespace-nowrap"
                >
                  <Send className="w-4 h-4 text-white" />
                  Send Invite
                </Button>
              </div>
            </CardContent>
          </Card>

          {/* Share Link Section */}
          <Card className="mb-8 shadow-lg border-0 bg-white/80 backdrop-blur-sm">
            <CardContent className="p-8">
              <div className="flex items-center gap-3 mb-4">
                <Copy className="w-6 h-6 text-emerald-600" />

                <h2 className="text-2xl font-semibold text-slate-800">
                  Share The Referral Link
                </h2>
              </div>
              <p className="text-slate-600 mb-6 leading-relaxed">
                You can also share your referral link by copying and sending it
                to your friends or sharing it on social media.
              </p>

              <div className="flex flex-col sm:flex-row gap-3">
                <Input
                  value={referralLink}
                  readOnly
                  className="flex-1 h-12 bg-slate-50 border-slate-200 text-slate-700"
                />
                <Button
                  // onClick={handleCopyLink}
                  variant="outline"
                  className="h-12 px-8 gap-2 border-emerald-200 text-emerald-700 hover:bg-emerald-50 whitespace-nowrap"
                >
                  <Copy className="w-4 h-4 text-emerald-700" />
                  Copy Link
                </Button>
              </div>
            </CardContent>
          </Card>

          {/* Earn Money Section */}
          <Card className="shadow-lg border-0 bg-gradient-to-r from-emerald-500 to-teal-600 text-white">
            <CardContent className="p-8">
              <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6">
                <div className="flex-1">
                  <div className="flex items-center gap-3 mb-4">
                    <Gift className="w-6 h-6 text-white" />

                    <h2 className="text-2xl font-bold">Earn Money!</h2>
                  </div>
                  <p className="text-emerald-50 leading-relaxed">
                    Bring 3 or more friends on board, and you'll get one month
                    free as our way of saying thanks. It's easy, rewarding, and
                    everyone benefits!
                  </p>
                </div>
                <div className="flex-shrink-0">
                  <Button
                    variant="secondary"
                    className="bg-white/20 hover:bg-white/30 text-white border-white/30 h-12 px-8 gap-2 backdrop-blur-sm"
                  >
                    <DollarSign className="w-4 h-4 text-white" />
                    Cash Out
                  </Button>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default ReferralPage;
